import { render, staticRenderFns } from "./exportShipmentBranchPostOfficeQty.vue?vue&type=template&id=02072a6a"
import script from "./exportShipmentBranchPostOfficeQty.vue?vue&type=script&lang=js"
export * from "./exportShipmentBranchPostOfficeQty.vue?vue&type=script&lang=js"
import style0 from "./exportShipmentBranchPostOfficeQty.vue?vue&type=style&index=0&id=02072a6a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports